<template>
  <div class="mb-4">
    <p><strong>{{ label }}</strong></p>
    <div class="row">
      <div class="col">
        <label class="control-label" for="response-display">Effect</label>
        <select v-model="content[key].animationEffects.responseDisplay" class="form-control">
          <option value="">None</option>
          <option value="animate__fadeIn">Fade In</option>
          <option value="animate__fadeInLeft">Fade In Left</option>
          <option value="animate__fadeInRight">Fade In Right</option>
          <option value="animate__fadeInUp">Fade In Up</option>
          <option value="animate__fadeInDown">Fade In Down</option>
        </select>
      </div>
      <div class="col">
        <label class="control-label" for="response-delay">Start Delay (seconds)</label>
        <input v-model="content[key].animationEffects.responseStartDelay" class="form-control" type="number">
      </div>
      <div class="col">
        <label class="control-label" for="response-delay">Between Delay (seconds)</label>
        <input v-model="content[key].animationEffects.responseBetweenDelay" class="form-control" type="number">
      </div>
    </div>
  </div>
</template>


<script>
export default {
  props: ['content', 'plabel', 'pkey'],
  data() {
    return {
      label: this.plabel || 'Choice Animation Controls',
      key: this.pkey || 'question'
    }
  }
}
</script>
